// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9923 ? "8e095c31" : chunkId) + "." + {"829":"0e4b47fb66b7e120","3845":"64ff41e8548720f1","9923":"2bd06c6d4370c3af"}[chunkId] + ".js";
};